<template>
  <div uk-height-viewport="offset-top: true" class="uk-flex uk-flex-center uk-flex-middle">
    <div class="uk-card uk-card-default uk-card-body uk-card-small uk-width-1-3">
      <h2 class="uk-margin-small">Create a New Project</h2>
      <form @submit.prevent="createProject">
        <div class="uk-margin">
          <input required class="uk-input" type="text" placeholder="Email" v-model="email" />
        </div>
        <div class="uk-margin">
          <input required class="uk-input" type="text" placeholder="Deal ID" v-model="dealID" />
        </div>
        <div class="uk-form-controls uk-margin">
          <select required class="uk-select" id="form-horizontal-select" v-model="type">
            <option>Organization</option>
            <option>Distributor</option>
            <option>Wedding</option>
            <option>Individual</option>
          </select>
        </div>
        <button type="submit" class="uk-button uk-button-primary uk-align-right">Create Project</button>
      </form>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import firebase from "firebase";
import router from "@/router";
import CrmService from "@/services/CrmService";

export default {
  name: "AdminCreateProject",
  data() {
    return {
      email: "",
      dealID: "",
      type: ""
    };
  },
  methods: {
    createProject() {
      var self = this;
      let project = {
        cart: [],
        email: self.email.toLowerCase(),
        name: "My Project",
        priceAdjustment: {
          amount: 0,
          label: ""
        },
        projectID: self.dealID,
        proofCount: 0,
        setupCharge: 20,
        swatches: [],
        type: self.type,
        created: new Date(Date.now())
      };
      if(self.type.toLowerCase().includes("distributor")){
        project.setupCharge = 0
      }
      const projectsRef = firebase.firestore().collection("projects");
      projectsRef
        .add(project)
        .then(function(docRef) {
          console.log("Document written with ID: ", docRef.id);
          router.push({ name: "ProjectAdmin", params: { id: self.dealID } });
        })
        .catch(function(error) {});

        let crmBody = {
          "dealID": self.dealID
        }
        CrmService.createProject(crmBody)
    }
  },
  computed: {},
  mounted: function() {},
  components: {},
  filters: {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminCreateProject.vue